import React from "react"
import ModalCustom from "../../../../components/ModalCustom"

import PropTypes from "prop-types"

import "./index.less"
import { ConfirmIcon } from "../../../../icons/svg/iconConfirm"

const CancelDrawerModal = (props) => {
  return (
    <ModalCustom
      modalOpen={props.show}
      showFooter
      onOk={() => {
        props.onOk()
      }}
      onCancel={() => props.onCancel()}>
      <>
        <ConfirmIcon />
        <p
          style={{
            paddingTop: "12px",
            paddingBottom: "12px",
            fontWeight: 600,
            fontSize: 14,
            textAlign: "center",
          }}>
          {props.primaryText}
        </p>
        <p>{props.secondaryText}</p>
      </>
    </ModalCustom>
  )
}

CancelDrawerModal.propTypes = {
  show: PropTypes.bool,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
}

export default CancelDrawerModal
